/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./bonus.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "@angular/router";
import * as i3 from "./bonus.component";
var styles_BonusComponent = [i0.styles];
var RenderType_BonusComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_BonusComponent, data: {} });
export { RenderType_BonusComponent as RenderType_BonusComponent };
export function View_BonusComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 16777216, null, null, 1, "router-outlet", [], null, null, null, null, null)), i1.ɵdid(1, 212992, null, 0, i2.RouterOutlet, [i2.ChildrenOutletContexts, i1.ViewContainerRef, i1.ComponentFactoryResolver, [8, null], i1.ChangeDetectorRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
export function View_BonusComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-bonus", [], null, null, null, View_BonusComponent_0, RenderType_BonusComponent)), i1.ɵdid(1, 114688, null, 0, i3.BonusComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var BonusComponentNgFactory = i1.ɵccf("app-bonus", i3.BonusComponent, View_BonusComponent_Host_0, {}, {}, []);
export { BonusComponentNgFactory as BonusComponentNgFactory };
